/**
 * @generated SignedSource<<3ad96d0a0afb16b14f6b2785739ee7ef>>
 * @relayHash 53d373cb837ddfa8bd4f877d70b76de1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a448ed94c295960b142f6203d70a59c2c7df255f0c22ec41a56ccc902cb5b344

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a448ed94c295960b142f6203d70a59c2c7df255f0c22ec41a56ccc902cb5b344",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
